import { GET_MY_ORGANIZATION_SUBORGS } from "./../graphql/queries/getMyOrganizationSuborgs"
import { useMutation } from "@apollo/client"
import { CREATE_NEW_ORGANIZATION } from "../graphql/mutations/createNewOrganization"
import { GET_USER } from "../graphql/queries/getUser"

export const useCreateNewOrganization = ({ onCompleted, onError }: { onCompleted: any; onError: any }) => {
  const [createNewOrganization, { client, data, loading }] = useMutation(CREATE_NEW_ORGANIZATION, {
    onCompleted: onCompleted,
    onError: onError,
    refetchQueries: [GET_USER, GET_MY_ORGANIZATION_SUBORGS],
  })

  return { createNewOrganization, data, loading, client }
}
